import { Component, Inject, OnInit, ViewEncapsulation } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { SharkifyAiSerivceService } from 'src/app/sharkify-ai-serivce.service';
import { Router } from '@angular/router';
import { DomSanitizer } from '@angular/platform-browser';
import { DatePipe } from '@angular/common';
import { SceduledEvent } from 'src/app/Models/ScheduledEventResponse';
import { AppComponent } from 'src/app/app.component';
import { SocialMediaAccount } from 'src/app/Models/SocialMediaAccountResponse';
import { ToastrService } from 'ngx-toastr';
@Component({
  selector: 'app-events',
  templateUrl: './events.component.html',
  styleUrls: ['./events.component.css']
})
export class EventsComponent implements OnInit {
  private currentDialogRef: MatDialogRef<ShowEvents> | null = null;
  weekDayNames: string[] = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
  displayedWeekDays: string[] = []; 
  currentView: 'weeks' | 'days' | 'months' = 'weeks';  // Add 'months'
  showEvents: boolean = false;
  currentMonth: Date = new Date();
  daysInMonth: any[] = [];
  events: any[] = [];
  selectedDate: Date | null = null;
  selectedEvents: any[] = [];
  editingEvent: any = null;
  view: 'days' | 'weeks' | 'months' = 'days'; 
  isweekly: boolean = false;
  ismonthly: boolean = true;
  ScheduledEventsData : SceduledEvent[] = [];
  CheckBusinessInfoId: string = "";
  UserId: string = "";
  SocialMediaAccountsData:SocialMediaAccount[]=[];
  selectedAccount: number = 0;
  
  getsafevalue(value : any){
    return this.sanitizer.bypassSecurityTrustHtml(value);
  }
  // view: 'days' | 'weeks' = 'days'; 
  currentWeekDays: any[] = [];

  constructor(public sanitizer: DomSanitizer,public dialog : MatDialog,public service:SharkifyAiSerivceService,public router: Router,public datepipe : DatePipe,public app: AppComponent, private toastr: ToastrService){}

  // ngOnInit(): void {
  //   this.loadEvents();  
  //   this.loadDaysInMonth(); 
  //   this.loadCurrentWeekDays(); 
  //   this.service.ScheduledEventsForSocialMediaAccount("17","24","3").subscribe(data => {
  //     if (data.Code == 200) {
  //       this.ScheduledEventsData=data.SceduledEvents;
  //     } else {
    
  //     }
  //   });
  // }
  getSafeValue(value:string | null):string{
    return (value=== null || value === "undefined") ? "" : value;
  }

  ngOnInit(): void {
    // Fetch scheduled events
    setTimeout(() => {
    this.UserId = this.getSafeValue(localStorage.getItem("UserId"));
    this.CheckBusinessInfoId=this.getSafeValue(localStorage.getItem("CheckBusinessInfoId"));
    this.loadEvents();  
        this.loadDaysInMonth(); 
        this.loadCurrentWeekDays(); 
    this.service.ListOfSocialMediaAccounts(this.UserId,this.CheckBusinessInfoId).subscribe(data => {
      this.SocialMediaAccountsData = data.SocialMediaAccounts;
      if(this.SocialMediaAccountsData.length > 0){
        this.selectedAccount=this.SocialMediaAccountsData[0].AccountId;
        this.getData();
        }
    });
  }, 100);
   
}
submit(){
 this.getData();
}

getData(){
  console.log(this.selectedAccount);
  this.app.displayLoader(true);
  console.log(this.UserId, this.CheckBusinessInfoId, this.selectedAccount)
    this.service.ScheduledEventsForSocialMediaAccount(this.UserId, this.CheckBusinessInfoId, this.selectedAccount).subscribe(data => {
      if (data.Code == 200) {
        this.ScheduledEventsData = data.SceduledEvents;
        console.log(data);
        // Now call functions that rely on this data
        this.loadEvents();  
        this.loadDaysInMonth(); 
        this.loadCurrentWeekDays(); 
        this.app.displayLoader(false);
      } else {
        this.app.displayLoader(false);
      }
    });
}
getImagePath(accountType: string): string {
  switch (accountType) {
    case 'Threads':
      return './assets/social_channel/threads.svg';
    case 'Facebook':
      return './assets/social_channel/facebook.svg';
    case 'Instagram':
      return './assets/social_channel/insta.svg';
    case 'X (Twitter)':
      return './assets/social_channel/twitter.svg';
    case 'LinkedIn':
      return './assets/social_channel/linkedin.svg';
    // Add more cases for additional account types if needed
    default:
      return ''; // Fallback image if no match
  }
}

  weeks() {
    this.isweekly = true;
    this.ismonthly = false;
    this.currentView = 'weeks'; // This will work
    this.loadCurrentWeekDays(); 
    
  }

  months() {
    this.isweekly = false;
    this.ismonthly = true;
    this.currentView = 'months'; 
    this.loadDaysInMonth();
  }
   
    setView(view: 'days' | 'weeks'): void {
      this.view = view;
      if (view === 'weeks') {
        this.loadCurrentWeekDays();
      }
    }
  prevMonth() {
    if (this.view === 'days') {
      this.currentMonth = new Date(this.currentMonth.setMonth(this.currentMonth.getMonth() - 1));
      this.loadDaysInMonth();
    } else if (this.view === 'weeks') {
      const firstDayOfWeek = this.currentWeekDays[0]?.date || new Date();
      const prevWeek = new Date(firstDayOfWeek.setDate(firstDayOfWeek.getDate() - 7));
      this.loadCurrentWeekDays(prevWeek);
    }
    this.selectedDate = null;
    this.selectedEvents = [];
  }
  
  nextMonth() {
    if (this.view === 'days') {
      this.currentMonth = new Date(this.currentMonth.setMonth(this.currentMonth.getMonth() + 1));
      this.loadDaysInMonth();
    } else if (this.view === 'weeks') {
      const lastDayOfWeek = this.currentWeekDays[6]?.date || new Date();
      const nextWeek = new Date(lastDayOfWeek.setDate(lastDayOfWeek.getDate() + 7));
      this.loadCurrentWeekDays(nextWeek);
    }
    this.selectedDate = null;
    this.selectedEvents = [];
  }
  loadDaysInMonth() {
    const daysInMonth = new Date(this.currentMonth.getFullYear(), this.currentMonth.getMonth() + 1, 0).getDate();
    const firstDayOfMonth = new Date(this.currentMonth.getFullYear(), this.currentMonth.getMonth(), 1).getDay();
    
    this.daysInMonth = Array.from({ length: daysInMonth }, (_, i) => ({
      date: new Date(this.currentMonth.getFullYear(), this.currentMonth.getMonth(), i + 1),
      events: this.getEventsForDate(new Date(this.currentMonth.getFullYear(), this.currentMonth.getMonth(), i + 1))
    }));
  
    for (let i = 0; i < firstDayOfMonth; i++) {
      this.daysInMonth.unshift({ date: null, events: [] }); 
    }
  }
  loadCurrentWeekDays(date: Date = new Date()) {
    const firstDayOfWeek = date.getDate() - date.getDay(); // Get Sunday of the week
    this.currentWeekDays = Array.from({ length: 7 }, (_, i) => ({
      date: new Date(date.getFullYear(), date.getMonth(), firstDayOfWeek + i),
      events: this.getEventsForDate(new Date(date.getFullYear(), date.getMonth(), firstDayOfWeek + i))
    }));
    this.updateDisplayedWeekDays();
  }
  

  updateDisplayedWeekDays() {
    const firstDayOfWeek = this.currentWeekDays[0]?.date.getDay(); 
    this.displayedWeekDays = this.weekDayNames.slice(firstDayOfWeek).concat(this.weekDayNames.slice(0, firstDayOfWeek));
  }

  // getEventsForDate(date: Date): any[] {
  //   return this.events.filter(event => new Date(event.date).toDateString() === date.toDateString());
  // }

  getEventsForDate(date: Date): SceduledEvent[] {
    return this.ScheduledEventsData.filter(event => {
      const eventDate = new Date(event.ScheduledDate);
      return eventDate.toDateString() === date.toDateString();
    });
  }
  
  loadEvents() {
    this.events = [
      {
        date: new Date(2024, 6, 5, 7, 0),
        time: '10:00 am - 1:00 pm',
        title: 'Conference',
        location: 'Farmer\'s Market Pavillion, Pittsburg',
        description: 'Farmer\'s Market Pavillion hosts a conference on web-readiness...',
        image: 'assets/event1.png.png',
        profileImage: 'assets/profile1.png',  
        postImage: 'assets/event1_instagram.png',  


      },
      {
        date: new Date(2024, 9, 23, 8, 0),
        time: '8:00 am - 5:00 pm',
        title: 'Conference',
        location: 'Farmer\'s Market Pavillion, Pittsburg',
        description: 'Farmer\'s Market Pavillion hosts a conference on web-readiness...',
        profileImage: 'assets/profile2.png',
        postImage: 'assets/event2_instagram.png',  
      },
      {
        date: new Date(2024, 9, 24, 18, 0),
        time: '6:00 pm - 9:30 pm', 
        title: 'Engineer Best-of-breed Web-readiness',
        location: 'Farmer\'s Market Pavillion, Pittsburg',
        description: 'An event by ABC Cooking School coming to Pittsburg!',
        image: 'assets/image1.png',
        profileImage: 'assets/image1.png', 
        postImage: 'assets/image2.png', 

      },
      {
        date: new Date(2024, 9, 24, 21, 30),
        time: '9:30 pm - 11:00 pm',
        title: 'Repurpose Initiatives',
        location: 'Race Start Line 601 Sherwood Ave., San Bernadino',
        description: 'Race Start Line hosts Repurpose Initiatives...',
        image: 'assets/image2.png',  
        profileImage: 'assets/image1.png', 
        postImage: 'assets/image2.png', 
      }
    ];
  }

   selectDate(event: MouseEvent, date: Date) {
    this.selectedDate = date;
    this.selectedEvents = this.getEventsForDate(date);
    this.opendialog(event);
  }
  opendialog(event: MouseEvent): void {
    if (this.dialog.openDialogs.length > 0) {
      this.dialog.closeAll();
    }
  
    // let Event_data = {
    //   sent_data: this.selectedEvents,
    //   acceptEvent: this.acceptEvent.bind(this),
    //   editEvent: this.editEvent.bind(this),
    //   declineEvent: this.declineEvent.bind(this),
      
    // };
    let Event_data = {
      sent_data: this.selectedEvents.map(event => ({
        ...event,
        accountName: 'Sharkify_ai'  
      })),
      acceptEvent: this.acceptEvent.bind(this),
      editEvent: this.editEvent.bind(this),
      declineEvent: this.declineEvent.bind(this),
    };
    
    const dialogRef = this.dialog.open(ShowEvents, {
      height: '100%',
      width: '100%',
      data: Event_data,
      backdropClass: 'black-backdrop',  
    });
  
    dialogRef.afterOpened().subscribe(() => {
      const dialogContainerElement = document.querySelector('.custom-dialog-container');
      if (dialogContainerElement) {
        const xPos = event.clientX;
        const yPos = event.clientY;
        // dialogContainerElement.setAttribute(
        //   'style',
        //   `position: fixed; top: ${yPos}px; left: ${xPos}px; transform: translate(-50%, -50%);`
        // );
        dialogContainerElement.setAttribute(
          'style',
          `position: fixed; top: 50%; left: 50%; transform: translate(-50%, -50%);`
        );
        
      }
    });
  
    dialogRef.backdropClick().subscribe(() => {
      dialogRef.close();
    });
  }
  
  editEvent(event: any) {
    this.editingEvent = { ...event }; 
  }
  
  saveEvent(event: any) {
    const index = this.events.findIndex(e => e.date.getTime() === event.date.getTime());
    if (index !== -1) {
      this.events[index] = this.editingEvent;
    }
    this.editingEvent = null;
  }
  
  cancelEdit() {
    this.editingEvent = null;
  }
  
  acceptEvent(event: any) {
    if (event.EventID) {
      this.service.approveEvent(event.EventID).subscribe(response => {
        this.toastr.success('Event Approved Successfully', 'Success');
        this.dialog.closeAll();
      });
    }
  }
  
  declineEvent(event: any) {
    const index = this.events.findIndex(e => e.date.getTime() === event.date.getTime());
    if (index !== -1) {
      this.events.splice(index, 1);
      this.selectedEvents = this.selectedEvents.filter(e => e.date.getTime() !== event.date.getTime());
    }
  }
  
}
export interface Event_details {
  sent_data: any[]; 
  acceptEvent: (event: any) => void;
  editEvent: (event: any) => void;
  declineEvent: (event: any) => void;
}

@Component({
  selector: 'app-show-Events',
  templateUrl: './Show-Events.component.html',
  styleUrls: ['./Show-Events.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class ShowEvents {
  accountName: string = ''; 
  getsafevalue(value : any){
    return this.sanitizer.bypassSecurityTrustHtml(value);
  }
  constructor(@Inject(MAT_DIALOG_DATA) public data: Event_details,public dialogRef: MatDialogRef<ShowEvents>,public sanitizer: DomSanitizer) {
    if (this.data && this.data.sent_data.length > 0) {
      this.accountName = this.data.sent_data[0].accountName || '';
      this.data.sent_data.forEach(event => {
        event.EventMediaLinks = event.EventMediaLinks?.replace("www.dropbox.com", "dl.dropboxusercontent.com");
      })
  }
}
  closeDialog(): void {
    this.dialogRef.close();
  }
}
